"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TenantFormContentModule = /** @class */ (function () {
    function TenantFormContentModule() {
    }
    return TenantFormContentModule;
}());
exports.TenantFormContentModule = TenantFormContentModule;
